import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getAllTypes } from '../../store/transportSlice'
import { getTypeFilter, setTypeFilter, getAvailableTypes } from '../../store/filterSlice'

import transport from './transport.svg'
import { Selector } from './Selector/Selector'

function TypesFilterBody({ types, selectedTypes, availableTypes, setTypeFilter }) {
    return (
        <Selector
            iconSrc={transport}
            title="По типу техники"
            options={types}
            selected={selectedTypes}
            enabledOptions={availableTypes}
            onChange={setTypeFilter}
        />
    )
}

TypesFilterBody.propTypes = {
    types: PropTypes.arrayOf(PropTypes.string),
    selectedTypes: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.oneOf([true]),
    ]),
    availableTypes: PropTypes.arrayOf(PropTypes.string),
    setTypeFilter: PropTypes.func.isRequired,
}

const TypesFilter = connect(
    state => ({
        types: getAllTypes(state),
        selectedTypes: getTypeFilter(state),
        availableTypes: getAvailableTypes(state),
    }), {
        setTypeFilter,
    },
)(TypesFilterBody)

TypesFilter.propTypes = {}

export { TypesFilter }
